<template>
  <app-drawer ref="appDrawer" v-loading="isLoading">
    <div class="el-drawer__content" v-loading="isLoading">
      <div class="el-drawer__content-wrapper">
        <div v-for="(form, index) in list" :key="index">
          <a
            href="#"
            class="text-danger"
            style="right:15px; margin-right: 15px; position: absolute; z-index: 2010"
            @click="deleteItem(form)"
            ><span class="el-icon-close"></span
          ></a>
          <el-form
            label-position="top"
            :model="form"
            :rules="rules"
            style="overflow-y: unset"
            ref="sparePartForms"
          >
            <el-row
              :gutter="15"
              style="border-bottom: 1px solid #DCDFE6; margin-bottom: 10px"
            >
              <el-col :md="12">
                <el-form-item label="Part" prop="part_no">
                  <el-select
                    filterable
                    clearable
                    v-model="form.part_no"
                    @blur="verifyAdd"
                  >
                    <el-option
                      v-for="part in parts"
                      :key="part.id"
                      :value="part.part_no"
                      :label="`${part.part_no} - ${part.description}`"
                      :disabled="isAdded(part)"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="Quantity" prop="quantity">
                  <el-input-number
                    v-model.number="form.quantity"
                    :controls="false"
                    @blur="verifyAdd"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <!-- <el-col :md="24">
                <el-form-item label="Remarks" prop="descrpiption">
                  <el-input
                    type="textarea"
                    v-model="form.description"
                  ></el-input>
                </el-form-item>
              </el-col> -->
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="el-drawer__footer">
        <el-button
          size="small"
          type="primary"
          @click="batchSave"
          :disabled="isLoading"
          >Save</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="addItem"
          :disabled="isLoading"
          >Add Item to Batch</el-button
        >
      </div>
    </div>
  </app-drawer>
</template>

<script>
import Part from "@/models/Part";
import ULD from "@/models/ULD";
import socket from "@/socket";
export default {
  name: "SpareParts_multiple",
  data() {
    return {
      isLoading: false,
      parts: [],
      list: [],
      // form: {
      //   part_no: "",
      //   part_description: "",
      //   description: "",
      //   quantity: 0,
      // },
      rules: {
        part_no: [
          { required: true, message: "Part details is required." },
          {
            validator: (rule, value, callback) => {
              var part = this.parts.find(o => {
                return o.part_no == value;
              });
              if (!part) {
                return callback(new Error("Part information not found."));
              }

              // if (
              //   "_default" in this.formModel &&
              //   this.formModel._default == value
              // )
              //   callback();

              // this.formModel.part_id = part.id;
              part = this.spareParts.data.find(o => {
                return o.requested_parts.part_no == value;
              });
              if (part) {
                return callback(new Error("This part is already added."));
              }

              part = this.approvedRequests.find(o => {
                return o.part_no == value;
              });
              // if (part) {
              //   return callback(
              //     new Error("This part is already on the approved requestss.")
              //   );
              // }

              callback();
            },
            trigger: "change"
          }
        ],
        quantity: [
          { required: true, message: "Quantity is required." },
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                return callback(new Error("Quantity is required."));
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    uld() {
      return this.$store.getters["uld/info"];
    },
    spareParts() {
      return this.$store.getters["uld/spareParts"];
    },
    approvedRequests() {
      return this.$store.getters["uld/stockoutItems"];
    }
  },
  methods: {
    open() {
      this.list = [
        {
          part_no: "",
          part_description: "",
          description: "",
          quantity: 0,
          _id: Date.now()
        }
      ];
      this.isLoading = true;
      Part.getGlossary().then(list => {
        this.isLoading = false;
        this.parts = list;
      });
      this.$refs.appDrawer.open();
    },
    close() {
      this.$refs.appDrawer.close();
    },
    addItem() {
      this.list.push({
        part_no: "",
        part_description: "",
        description: "",
        quantity: 0,
        _id: Date.now()
      });
    },
    verifyAdd() {
      let empty = this.list.find(o => o.part_no === "" || o.quantity === "");
      if (!empty) {
        this.addItem();
      }
    },
    batchSave() {
      this.$confirm("Do you want to submit this request?")
        .then(() => {
          let isValid = true;

          let ctr = 0;
          let validated = 0;
          for (let form of this.$refs.sparePartForms) {
            if (form) {
              let item = this.list[ctr];
              if (item.part_no) {
                form.validate(valid => {
                  validated++;
                  if (!valid) isValid = false;
                });
              }
              ctr++;
            }
          }

          if (validated == 0) {
            // at least one record is required
            this.$notify({
              type: "error",
              message: "Request should contain at least 1 part.",
              position: "bottom-right"
            });
            return;
          }

          if (isValid) {
            // let promises = [];
            let payloads = [];
            this.isLoading = true;
            // let _resp = {};
            for (let item of this.list) {
              if (!item.part_no) continue;

              let payload = {
                uld_id: this.uld.id,
                description: item.description,
                mechanic_id: this.user.id,
                quantity: item.quantity
              };

              var part = this.parts.find(o => {
                return o.part_no == item.part_no;
              });
              if (part) {
                payload.parts_id = part.id;
              }
              payloads.push(payload);

              // promises.push(
              //   ULD.request_part(payload).then(resp => {
              //     _resp = resp;
              //   })
              // ULD.request_part(payload).then(resp => {
              //   socket.emit("send_notification", {
              //     sendto: "supervisor",
              //     channel: `room-channel.${resp.notification.notify_to_id}`,
              //     data: resp.notification
              //   });
              // })
              // );
            }
            ULD.request_part({ data: payloads, uld_id: this.uld.id }).then(
              resp => {
                // _resp = resp;
                // });
                // Promise.all(promises).then(() => {

                this.isLoading = false;
                this.$notify({
                  type: "success",
                  message: "Request saved successfully.",
                  position: "bottom-right"
                });

                // notify once
                socket.emit("send_notification", {
                  sendto: "supervisor",
                  channel: `room-channel.${resp.notification.notify_to_id}`,
                  data: resp.notification
                });

                this.$store.dispatch("uld/fetchSpareParts", this.uld.id);
                this.close();
              }
            );
          }
        })
        .catch(() => {});
    },
    deleteItem(item) {
      this.list = this.list.filter(o => o._id != item._id);
    },
    isAdded(part) {
      let check = this.list.find(o => o.part_no == part.part_no);
      if (check) return true;
      return false;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
